import { StripeError } from '@stripe/stripe-js';

export const ADD_PAYMENT_METHOD_FALLBACK_ERROR =
  'We could not add your payment method. Please try a different card or contact support@theinformation.com.';

export const BILLING_ADDRESS_FALLBACK_ERROR =
  'We could not save your billing address. Please check the address and try again.';

type SetupIntentLike = {
  last_setup_error?: {
    message?: string | null;
  } | null;
} | null;

export function stripeSetupErrorMessage(
  error?: StripeError | null,
  setupIntent?: SetupIntentLike
): string {
  return (
    error?.message || setupIntent?.last_setup_error?.message || ADD_PAYMENT_METHOD_FALLBACK_ERROR
  );
}
